import { useGLTF, Edges, PresentationControls, Center } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import React, { useRef } from "react";
import * as THREE from 'three'


const material = new THREE.MeshStandardMaterial({
    color: '#ffffef',
})


export const Acaring = React.forwardRef((props, ref) => {

    const { nodes } = useGLTF(import.meta.env.BASE_URL + 'static/models/acaring.glb')




    return <>
        <mesh {...props} ref={ref} dispose={null} geometry={nodes.Extrusion.geometry} material={material}>
            <Edges
                geometry={nodes.Extrusion.geometry}
                lineWidth={0.7}
                threshold={0.5}
                color="black"
                scale={1}
                opacity={.8}
                depthTest={true}
                depthWrite={false}
                renderOrder={1000}
                polygonOffset={false}
                polygonOffsetFactor={10}
            />
        </mesh>

    </>




})

useGLTF.preload(import.meta.env.BASE_URL + 'static/models/acaring.glb')